import ReduxStore from '../../../ReduxStore';
import {findReportTypeSection} from 'ducks/reportSections';
import {storedComparableItems} from 'api/reports/comparable/StoredComparableItems';
import {getComparableTemplateName} from 'lib/ReportUtil';
import {disclosedSalePrice} from 'api/reports/comparable/DisclosedSalePrice';
import resizedDasWebUri, {modes, presetDimensions} from 'components/imaging/ResizedDasWebImage';
import {maskRequest} from 'lib/PropertyUtils';
import RapidUtils from 'lib/RapidUtils';
import {COMPARABLE_TYPE} from 'lib/ComparablesActionsUtil';

export const makeFeaturedPropertySection = (propertyId, sectionName, reportSections) => {
    const {
        featureFlags: {
            enableUndisclosedPriceInCMAReport = false
        }, propertyDetail, propertyNotes, userSettings
    } = ReduxStore.getState();
    const comparableSection = findReportTypeSection(reportSections, sectionName);
    let comparableItems = storedComparableItems(sectionName);

    const comparableType = comparableItems.comparableType;
    const property = comparableItems.properties[propertyId];
    let templateVersion = 5;
    const template = getComparableTemplateName('FEATURED', templateVersion);
    const salePrice = (sectionName === 'COMPARABLE_SALES') ? disclosedSalePrice(enableUndisclosedPriceInCMAReport, property) : property.salePrice;
    const notes = propertyNotes[propertyId] && propertyNotes[propertyId].note;
    let data = {
        ...property,
        notes,
        notesTitle: notes && userSettings.notesTitle,
        featuredPhotos: [0, 1, 2]
            .map(i => {
                const featuredPhoto = property.featuredPhotos && property.featuredPhotos[i];
                return featuredPhoto === undefined || featuredPhoto === null ?
                    property.propertyPhotoList[i] : featuredPhoto;
            })
            .map(url =>
                resizedDasWebUri({
                    uri: url,
                    mode: modes.EXACT,
                    resizeDimensions: presetDimensions.LARGE
                }) || null
            ),
        targetCoordinates: {latitude: propertyDetail.latitude, longitude: propertyDetail.longitude},
        comparableType,
        salePrice,
        ...(comparableType !== COMPARABLE_TYPE.SALES ? RapidUtils.sanitizeListing(comparableType, {
            salePrice,
            saleDate: property.saleDate,
            rentalLastCampaignLastListedPeriod: property.rentalLastCampaignLastListedPeriod,
            displayFields: property.displayFields,
        }) : {}),
        priceChangeIncluded: true,
    };
    data = maskRequest(data, property.displayFields);
    return {
        name: 'FEATURED',
        title: comparableSection.sectionData.title,
        template,
        data,
        pdf: undefined,
    };
};
